export const FlagComponent = ({ country }: { country: string }) => {
  const style = {
    display: "flex",
    flexShrink: 0,
    width: "24px",
    minHeight: "24px",
    height: "24px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    borderRadius: "50%",
    backgroundImage: `url(https://flagcdn.com/w320/${country?.toLowerCase()}.png)`,
    border: "1px solid #DEDEDE",
  };
  return <span style={style}></span>;
};
